import React from "react";
import { Button, Stack, alpha } from "@mui/material";
import {
  Refresh as RefreshIcon,
  Description as TemplateIcon,
  LibraryBooks as MasterIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import PageContentLayout from "../components/layout/PageContentLayout";
import WhatsAppTemplates from "../components/whatsapp/admin/WhatsAppTemplates";

/** EduOK yellow — matches Manage WhatsApp Accounts header chrome */
const YELLOW = {
  light: "#fff8e1",
  mid: "#ffecb3",
  main: "#ffd54f",
  strong: "#ffc107",
  border: "#ffe082",
};

const HEADER_BTN_SX = {
  textTransform: "none",
  fontWeight: 700,
  fontSize: "0.78rem",
  letterSpacing: "0.01em",
  lineHeight: 1.25,
  minHeight: 34,
  px: 1.35,
  py: 0.45,
  borderRadius: "8px",
  borderWidth: "1.5px",
  boxShadow: "none",
  transition:
    "transform 0.16s ease, box-shadow 0.16s ease, background-color 0.16s ease, border-color 0.16s ease",
  "& .MuiButton-startIcon": {
    marginRight: 0.55,
    marginLeft: -0.1,
    "& > *:nth-of-type(1)": { fontSize: 15 },
  },
  "&:hover": { transform: "translateY(-1px)" },
};

/**
 * School Templates (/whatsapp/templates) or Template Master (/whatsapp/templates/master).
 */
const WhatsAppTemplatesPage = () => {
  const location = useLocation();
  const isMaster = /\/whatsapp\/templates\/master\/?$/.test(location.pathname);
  const view = isMaster ? "master" : "school";

  const [refreshKey, setRefreshKey] = React.useState(0);
  const [addRequestKey, setAddRequestKey] = React.useState(0);

  const title = isMaster ? "WhatsApp Template Master" : "WhatsApp School Templates";
  const crumbLabel = isMaster ? "Template Master" : "School Templates";
  const CrumbIcon = isMaster ? MasterIcon : TemplateIcon;

  return (
    <PageContentLayout
      title={title}
      darkBar
      barSx={{ minHeight: 68, py: 1.75, px: 2.75 }}
      breadcrumbs={[
        {
          label: crumbLabel,
          icon: <CrumbIcon sx={{ color: "#ffffff", fontSize: 18 }} />,
        },
      ]}
      backTo="/whatsapp/accounts"
      actions={
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center">
          <Button
            variant="outlined"
            size="small"
            disableElevation
            startIcon={<RefreshIcon sx={{ fontSize: 15 }} />}
            onClick={() => setRefreshKey((k) => k + 1)}
            sx={{
              ...HEADER_BTN_SX,
              bgcolor: alpha(YELLOW.light, 0.12),
              borderColor: alpha(YELLOW.border, 0.75),
              color: "#fff",
              backdropFilter: "blur(6px)",
              "&:hover": {
                bgcolor: alpha(YELLOW.mid, 0.32),
                borderColor: YELLOW.main,
                color: "#fff",
                boxShadow: `0 6px 16px -10px ${alpha(YELLOW.strong, 0.45)}`,
              },
            }}
          >
            Refresh
          </Button>
          {!isMaster && (
            <Button
              variant="contained"
              size="small"
              disableElevation
              startIcon={<AddIcon sx={{ fontSize: 15 }} />}
              onClick={() => setAddRequestKey((k) => k + 1)}
              sx={{
                ...HEADER_BTN_SX,
                bgcolor: YELLOW.strong,
                borderColor: YELLOW.main,
                color: "#fff",
                boxShadow: `0 8px 20px -10px ${alpha(YELLOW.strong, 0.7)}`,
                "&:hover": {
                  bgcolor: "#ffb300",
                  borderColor: YELLOW.main,
                  color: "#fff",
                  boxShadow: `0 10px 22px -10px ${alpha(YELLOW.strong, 0.85)}`,
                },
              }}
            >
              Add template
            </Button>
          )}
        </Stack>
      }
    >
      <WhatsAppTemplates
        view={view}
        refreshSignal={refreshKey}
        openCreateSignal={isMaster ? 0 : addRequestKey}
      />
    </PageContentLayout>
  );
};

export default WhatsAppTemplatesPage;
